module.exports = __webpack_public_path__ + "img/logo-text.78a52160.svg";